import { AnswerType } from '@/domains/AnswerType'
import { useState } from 'react'
import { DiagnosisQuestionDto } from '@/infra/api/generated/model'

const useQuestionAnswers = (questions: DiagnosisQuestionDto[]) => {
  const initialAnswers = questions.reduce(
    (acc: Record<string, AnswerType | null | undefined>, q) => {
      acc[q.questionId] = q.answer
      return acc
    },
    {}
  )
  const [answers, setAnswers] =
    useState<Record<string, AnswerType | null | undefined>>(initialAnswers)
  const updateAnswer = (questionId: string, answer: AnswerType) => {
    setAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: answer }))
  }
  return { answers, updateAnswer }
}

export default useQuestionAnswers
